// extracted by mini-css-extract-plugin
export default {"additional":"LandHeader_additional__d12FF","element":"LandHeader_element__GHt4c"};